import { disputeReason } from "@redotech/redo-dispute-db-schema/dispute-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { reclaimWinRateTimeWindow } from "./reclaim-win-rate-time-window";

export const reclaimWinRateByReasonRowSchema = z.object({
  reason: z.enum(disputeReason).nullable(),
  networkReasonCode: z.string().nullable(),
  won: z.number().int(),
  lost: z.number().int(),
  wonExcludingProtected: z.number().int(),
  lostExcludingProtected: z.number().int(),
});

export interface ReclaimWinRateByReasonRow extends z.infer<
  typeof reclaimWinRateByReasonRowSchema
> {}

export const getReclaimWinRateByReason = unaryRpc({
  name: "getReclaimWinRateByReason" as const,
  input: z.object({ timeWindow: z.enum(reclaimWinRateTimeWindow) }),
  output: z.object({ rows: z.array(reclaimWinRateByReasonRowSchema) }),
});
